module.exports = __webpack_public_path__ + "static/media/pattern-active.4d993018.svg";